
































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { storeRefFaskes } from "@/store/modules/bridgingVclaim/RefFaskes";
import { storeRefDiagnosa } from "@/store/modules/bridgingVclaim/RefDiagnosa";
import Rujukan from "@/services/bridgingVclaim/Rujukan";
import { appModule } from "@/store/modules/app";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import ModalKonfirmasi from "@/components/modal/ModalKonfirmasi.vue";

@Component({
  components: {
    ModalKonfirmasi,
  },
})
export default class InputRujukan extends Vue {
  @Prop() noSep: string;

  tglRujukan = "";
  tipeRujukan = "";
  jnsPelayanan = "";
  tglRencKunjungan = "";
  ppkRujukan = "";
  unitTujuan = "";
  diag = "";
  catatan = "";
  user = "coba ws";
  nomorSep = "";
  noRujukan = "";

  tglRujukanShow = false;
  tglRencKunjunganShow = false;
  saving = false;
  printing = false;
  deleting = false;
  modalOpenKonfirmasi = false;
  msgConfirm = "";

  tipeRujukanOpts = [
    { id: "0", name: "Penuh" },
    { id: "1", name: "Parsial" },
    { id: "2", name: "Rujuk Balik PRB" },
  ];
  jnsPelayananOpts = [
    { id: "1", name: "Rawat Inap" },
    { id: "2", name: "Rawat Jalan" },
  ];

  get sep() {
    return storeSEP.sep;
  }

  @Watch("sep")
  changedNoSep(val) {
    this.nomorSep = val.noSep;
    if (val.rujukanKeluar) {
      const rujukan = val.rujukanKeluar;

      this.tglRujukan = rujukan.tglRujukan;
      this.tglRencKunjungan = rujukan.tglRencanaKunjungan;
      this.jnsPelayanan = rujukan.jnsPelayanan;
      this.tipeRujukan = rujukan.tipeRujukan;
      this.ppkRujukan = rujukan.ppkDirujuk.kode;
      this.unitTujuan = rujukan.poliTujuan.kode;
      this.diag = rujukan.diagnosa.kode;
      this.catatan = rujukan.catatan;
      this.noRujukan = rujukan.noRujukan;
    } else {
      this.tglRujukan = moment().format("YYYY-MM-DD");
    }
  }

  get dataSend() {
    return {
      noSep: this.nomorSep,
      no_rujukan: this.noRujukan,
      tgl_rujukan: this.tglRujukan,
      tgl_rencana_kunjungan: this.tglRencKunjungan,
      ppk_dirujuk_id: this.ppkRujukan,
      jns_pelayanan: this.jnsPelayanan,
      catatan: this.catatan,
      diagnosa_id: this.diag,
      tipe_rujukan_id: this.tipeRujukan,
      poli_rujukan_id: this.unitTujuan,
      user: this.user,
    };
  }

  get listPPKRujukan() {
    return storeRefFaskes.refFaskes;
  }

  get listDiagnosis() {
    return storeRefDiagnosa.refDiagnosa;
  }

  get listUnitTujuan() {
    return [
      { id: "INT", name: "Klinik Dalam" },
      { id: "GIG", name: "Klinik Gigi" },
    ];
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }

  clearData() {
    this.noRujukan = "";
    this.tglRujukan = moment().format("YYYY-MM-DD");
    this.tglRencKunjungan = "";
    this.ppkRujukan = "";
    this.jnsPelayanan = "";
    this.catatan = "";
    this.diag = "";
    this.tipeRujukan = "";
    this.unitTujuan = "";
  }

  konfirmHapus() {
    this.modalOpenKonfirmasi = true;
    this.msgConfirm = `Anda yakin ingin menghapus Rujukan Keluar dengan no: ${this.noRujukan} ini?`;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      Rujukan.create(this.dataSend)
        .then((resp) => {
          if (resp.status == 1) {
            this.noRujukan = resp.data.noRujukan;
            appModule.NoticeDelay("Berhasil Membuat Rujukan");
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .catch((resp) => {
          appModule.sendErrorAlert(resp.message);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  async update() {
    if (!this.saving) {
      this.saving = true;

      try {
        const resp = await Rujukan.update(this.dataSend);

        this.saving = false;

        if (resp.status == 1) {
          if (typeof resp.data === "string") {
            Rujukan.getRujukanKeluarByNoRujukan(resp.data)
              .then((res) => {
                if (res.status === 1) {
                  this.noRujukan = res.data.noRujukan;

                  appModule.NoticeDelay("Rujukan keluar diupdate...");
                } else {
                  appModule.sendErrorAlert(
                    "Tidak ditemukan rujukan dg nomor " + resp.data
                  );
                  this.clearData();
                }
              })
              .catch(() => {
                appModule.sendErrorAlert(resp.message);
              });
          }

          appModule.NoticeDelay("Berhasil Mengubah Rujukan");
        } else {
          appModule.sendErrorAlert(resp.message);
        }
      } catch {
        this.saving = false;
      }

      this.saving = false;
    }
  }

  print() {
    Rujukan.print(this.noRujukan);
  }

  async remove() {
    if (!this.deleting) {
      this.deleting = true;

      const resp = await Rujukan.remove({
        no_rujukan: this.noRujukan,
        user: this.user,
      });

      console.log(resp);
      // this.noRujukan = resp.noRujukan;
      this.deleting = false;
      appModule.NoticeDelay("Berhasil Menghapus Rujukan");
      this.clearData();
    }
  }
}
